import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Item, toItemXml } from '../../dataObjects/Item';

export interface ICreateItemRequest extends IBaseRequest {
    ITEM:      Item;
}

export class CreateItemRequest extends BaseRequest implements ICreateItemRequest {
    public ITEM: Item;

  constructor(server: string, session: string, item: Item) {
    super(server, session);
    this.ITEM = item;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += toItemXml(this.ITEM);
    return super.wrapperXml('CreateItem', parameters);
  }
}
